import { Link } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function About() {
  usePageTitle("About Maqam · Community-Led Umrah");
  return (
    <div data-testid="page-about">
      <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <span className="overline">About Maqam</span>
            <h1 className="font-serif text-5xl md:text-7xl text-navy mt-3 leading-[1.02] tracking-tight">
              Built on knowledge.<br />Grounded in community.
            </h1>
            <div className="mt-8 space-y-5 text-[var(--maqam-muted)] leading-relaxed text-base md:text-lg">
              <p>
                Maqam Community Initiatives organizes community-led Umrah experiences and
                faith-based community programs. Our purpose is simple: bring believers
                closer to their Lord, to their community, and to the sacred history that
                shaped this Ummah.
              </p>
              <p>
                Every Maqam journey is designed with intention. We pair premium logistics
                — 5-star accommodations, the Haramain high-speed train, daily breakfast —
                with what most tours forget: knowledge, companionship, and care.
              </p>
              <p>
                Beyond travel, we run educational seminars, youth and community programs,
                and dedicated support for new Muslims. The goal is the same in every
                room and every flight: a community that knows its faith and loves it.
              </p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden rounded-2xl">
              <img
                src="https://images.pexels.com/photos/5620451/pexels-photo-5620451.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200"
                alt="Pilgrims gathered as one community"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[var(--maqam-surface)]">
        <div className="max-w-5xl mx-auto px-5 md:px-8 text-center">
          <span className="overline">Compliance & Partnership</span>
          <h2 className="font-serif text-3xl md:text-4xl text-navy mt-3 tracking-tight">
            Travel managed by a licensed partner
          </h2>
          <p className="mt-6 text-[var(--maqam-muted)] leading-relaxed">
            Maqam Community Initiatives facilitates community organization, education,
            group coordination, and traveller support. All travel bookings, travel
            services, flights, accommodations, visas, transportation, and package
            fulfillment are provided and managed by{" "}
            <span className="text-navy font-semibold">Amax Travel Canada, TICO Registration #50027257</span>.
          </p>
          <Link
            to="/contact"
            data-testid="about-contact-cta"
            className="mt-10 inline-flex btn-primary rounded-full px-7 py-3 font-semibold"
          >
            Get in Touch
          </Link>
        </div>
      </section>
    </div>
  );
}
